<template>
	<inertia-head title="Create Post" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h1 class="fw-bold text-white mb-2">
						Create Post
					</h1>
				</div>
			</div>
		</div>
	</div>

	<div class="content">
		
		<div class="row">
			<div class="col-lg-8 mb-6">
				<div class="mb-4">
					<label class="form-label" for="community_uuid">Select Community </label>
					<select v-model="formPost.community_uuid" name="community_uuid" class="form-select">
						<option v-for="(community, cIndex) in communities" :value="community.community_uuid+'|'+community.community_name">{{community.community_name}}</option>
					</select>
					<div v-if="formPost.errors.community_uuid && (formPost.community_uuid=='' || formPost.community_uuid==null)" class="show-error">
						<i class="fa fa-exclamation-circle"></i>
						{{ formPost.errors.community_uuid }}
					</div>
				</div>
				<div class="mb-4">
					<label class="form-label" for="title">Title </label>
					<input type="text" v-model="formPost.title" name="title" class="form-control">
				</div>
				<div class="mb-4">
					<label class="form-label" for="description">Description</label>
					<textarea v-model="formPost.description" name="description" rows="5" class="form-control"></textarea>
				</div>
				<div class="mb-4">
					<label class="form-label" for="date_schedule">Post Date </label>
					<div class="row">
						<div class="col">
							<div class="form-floating">
								<input v-model="formPost.date_schedule" type="date" name="date_schedule" class="form-control" placeholder="Date" />
								<label class="form-label" for="date_schedule">Date </label>
							</div>
						</div>
						<div class="col">
							<div class="form-floating">
								<input v-model="formPost.time_schedule" type="time" name="time_schedule" class="form-control" placeholder="Time" />
								<label class="form-label" for="time_schedule">Time </label>
							</div>
						</div>
					</div>
				</div>

				<div class="mb-4">
					<button @click="createPost" type="button" class="text-end btn btn-alt-success" :disabled="formPost.processing">
						<div
							v-if="formPost.processing"
							class="spinner-border spinner-border-sm text-dark me-1"
							role="status"
						>
							<span class="sr-only">Loading...</span>
						</div>
						<i v-else class="fa fa-save me-1"></i>
						<span>Create Post</span>
					</button>
				</div>
			</div>

			<div class="col-lg-4 mb-6">

			</div>

		</div>

	</div>
</template>

<script>
import { watch, onMounted, ref } from 'vue';
import AuthLayout from '../../../Layouts/AuthLayout';
import { createToaster } from '@meforma/vue-toaster';
import { useForm, usePage } from '@inertiajs/inertia-vue3';
import { Inertia } from '@inertiajs/inertia';

export default {
	props:{
		flash 		: Object,
		errors 		: Object,
		communities : Object
	},
	layout: AuthLayout,
	setup(props) {

		const toast = createToaster();

		const formPost = useForm({
			community_uuid 		: null,
			title 				: null,
			description 		: null,
			image_name 			: null,
			date_schedule 		: null,
			time_schedule 		: null,
		});

		const createPost = ()=>{
			let community = formPost.community_uuid.split("|");
			let community_name = "";
			
			formPost.community_uuid = community[0];
			
			community_name = community[1];

			formPost.post(route('member.community.post-store'), {
							preserveState: true,
							preserveScroll: true,
							only: ['flash','errors'],
							onSuccess:()=>{
								if(props.flash.toast.type=="success"){

									if(props.flash.toast.data.is_comm){
										Inertia.visit('/member/community/'+community_name,{method:'get'});
									}
									
									formPost.reset();
								}
							}
						})
		}


		return{
			toast,
			formPost,
			createPost
		}

	}
}
</script>